import React, { useEffect, useState } from 'react';
import { Alert, Box, CircularProgress, Typography } from '@mui/material';
import { API_MY_TEACHER_PROFILE } from '../Config/ApiUrlConstant';
import { teacherRequest } from './api';
import { TeacherDetail } from '.';

export default function MyTeacherProfile() {
  const [teacher, setTeacher] = useState(null); const [error, setError] = useState('');
  useEffect(() => { teacherRequest(API_MY_TEACHER_PROFILE, {}).then((payload) => setTeacher(payload.data)).catch((requestError) => setError(requestError.message)); }, []);
  return <Box><Typography variant="h5" sx={{ mb: 2 }}>My teacher profile</Typography>{error && <Alert severity="error">{error}</Alert>}{!error && !teacher && <CircularProgress />}{teacher && <TeacherDetail teacher={teacher} allowAudit={false} />}</Box>;
}
